import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {fetchAppIfNeeded} from '../actions/apps';
import Permissions from '../components/Permissions';

class PermissionsModal extends React.Component {

  static fetchData(dispatch, params) {
    const appSlug = params.appSlug;
    return dispatch(fetchAppIfNeeded(appSlug));
  }

  render() {
    const {data, isDemoMode} = this.props;

    return (
      <div className="permission-modal">
        {this.props.isFetching ?
          <div>Loading</div> :
          <Permissions app={data} isDemoMode={isDemoMode}/> }
      </div>
    );
  }
}

PermissionsModal.propTypes = {
  data: PropTypes.object,
  isFetching: PropTypes.bool.isRequired,
  dispatch: PropTypes.func,
  isDemoMode: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired
};


function mapStateToProps(state, props) {
  const appSlug = props.params.appSlug;
  const {data, isFetching} = state.apps.list[appSlug] || {data: {}, isFetching: true};
  return {data, isFetching, isDemoMode: !!state.mode.query.demoMode};
}

export default connect(mapStateToProps)(PermissionsModal);



// WEBPACK FOOTER //
// ./containers/Permissions-modal.js